import React from "react";
import Box from "../../lib/appfuse-react/component/Box";
import {withDesktop} from "../../layout/Desktop";

function Main(props) {
    return (
        <Box className="app-main" fullWidth fullHeight backgroundOpacity={0.5} backgroundColor="black">
        </Box>
    );
}

export default withDesktop(Main);